<template>
  <div class="ask-bid-prices">
    <div class="title-container">
      <div class="bid">
        {{ $t('trade.bid')
        }}<NbboIcon v-if="isShowNBBOIcon" :symbol="stock.symbol" />
      </div>
      <div class="ask">
        {{ $t('trade.ask') }}
      </div>
    </div>
    <div v-if="showData && hasVolume">
      <div class="volume-container">
        <div class="bid-vol" :style="{ width: bidDisplayVolPercent + '%' }">
          <span>{{ bidDisplayVolPercent + '%' }}</span>
        </div>
        <div class="ask-vol" :style="{ width: askDisplayVolPercent + '%' }">
          <span>{{ askDisplayVolPercent + '%' }}</span>
        </div>
      </div>
      <div class="price-container">
        <div class="bid-list">
          <div v-for="(bid, index) in prices.bid" :key="index" class="bid-info">
            <span v-blink.border.upDown="getAskBid(bid.price)">{{
              (bid.price || '--') | floatNum(stock)
            }}</span>
            <span v-blink.border.upDown="getAskBid(bid.volume)">{{
              bid.volume || '--'
            }}</span>
          </div>
        </div>
        <div class="ask-list">
          <div v-for="(ask, index) in prices.ask" :key="index" class="ask-info">
            <span v-blink.border.upDown="getAskBid(ask.volume)">{{
              ask.volume || '--'
            }}</span>
            <span v-blink.border.upDown="getAskBid(ask.price, index)">{{
              (ask.price || '--') | floatNum(stock)
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="volume-container">
        <div class="bid-vol placeholder-width">
          <span>{{ '0.00%' }}</span>
        </div>
        <div class="ask-vol placeholder-width">
          <span>{{ '0.00%' }}</span>
        </div>
      </div>
      <div class="price-container">
        <div class="bid-list">
          <div v-for="n in placeholderNum" :key="n" class="bid-info">
            <span>--</span>
            <span>--</span>
          </div>
        </div>
        <div class="ask-list">
          <div v-for="n in placeholderNum" :key="n" class="ask-info">
            <span>--</span>
            <span>--</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import choiceFilter from 'utils/choiceFilter'
import NbboIcon from 'mod/NbboIcon'
import stockMixin from 'mixins/stockMixin'

export default {
  name: 'OneTenChart',
  components: { NbboIcon },
  mixins: [stockMixin],
  props: [
    'stock',
    'prices',
    'context',
    'showData',
    'bidDisplayVolPercent',
    'askDisplayVolPercent'
  ],
  data: () => ({
    isChange: false
  }),
  computed: {
    ...mapGetters(['isDeposited', 'isVirtual', 'usMarketOpen']),
    curStock() {
      if (!this.stock.digits) {
        this.stock.digits = choiceFilter(this.stock)
      }
      return this.stock
    },
    placeholderNum() {
      const aStock = ['SH', 'SZ'].indexOf(this.stock.market) > -1
      if (aStock) {
        return 5
      }
      return this.stock.market === 'HK' ? 10 : 1
    },
    hasVolume() {
      const hasBidVol = this.bidDisplayVolPercent > 0
      const hasAskVol = this.askDisplayVolPercent > 0
      return hasBidVol || hasAskVol
    },
    isShowNBBOIcon() {
      return (
        this.context === 'trade' &&
        !this.isVirtual &&
        this.isDeposited &&
        this.isUS &&
        this.usMarketOpen &&
        this.isSTK &&
        !this.isIndex &&
        !this.isOTC
      )
    }
  },
  methods: {
    getAskBid(val, index) {
      // TODO 目前美股price.ask数组只有一个元素，后续有非美股再处理
      return val
    }
  },
  watch: {
    'stock.webLocal.symbol'(symbol) {
      this.isChange = !this.isChange
    }
  }
}
</script>
<style lang="less" scoped>
@import '~uikit';

.ask-bid-prices {
  padding: 10px;
  .placeholder-width {
    width: 50%;
  }
  .title-container,
  .volume-container,
  .price-container,
  .bid-vol,
  .ask-vol,
  .bid-info,
  .ask-info {
    display: flex;
    flex-direction: row;
  }
  .title-container {
    align-items: center;
    justify-content: space-between;
    padding: 6px 5px;
    .ask,
    .bid {
      display: flex;
      align-items: center;
      flex: 1;
      font-weight: bold;
      color: @bid-color;
    }
    .ask {
      justify-content: flex-end;
      color: @ask-color;
    }
  }
  .volume-container {
    height: 20px;
    color: #ffffff;
    .bid-vol,
    .ask-vol {
      position: relative;
      align-items: center;
    }
    .bid-vol {
      background-color: @bid-color;
      span {
        left: 5px;
      }
    }
    .ask-vol {
      background-color: @ask-color;
      span {
        right: 5px;
      }
    }
    span {
      position: absolute;
      z-index: 1;
    }
  }
  .price-container {
    .bid-list,
    .ask-list {
      display: flex;
      flex-direction: column;
      width: 50%;
      .bid-info,
      .ask-info {
        height: 20px;
        justify-content: space-between;
        align-items: center;
        padding: 0 5px;
      }
    }
    .bid-list {
      background: rgba(246, 74, 74, 0.1);
    }
    .ask-list {
      background: rgba(50, 140, 243, 0.1);
    }
  }
}
</style>
